import { jsxs as u, jsx as o } from "react/jsx-runtime";
import { c as h } from "../../../index-Cu0xwYjD.js";
import { s as e } from "../../../MenuItem.module-yHlnFmzE.js";
import { HeadingLevel as v } from "../../../utils/enums.js";
import { useMenu as f } from "../hooks/useMenu.js";
import { useMenuItemRole as p } from "../MenuItem/hooks/useMenuItemRole.js";
const g = ({
  append: r,
  children: i,
  className: m,
  divider: a,
  level: l = "h2",
  prepend: t,
  role: n,
  ...c
}) => {
  const s = f(), d = p() ?? n;
  return /* @__PURE__ */ u(
    "div",
    {
      ...c,
      className: h(
        m,
        e.menuItem,
        e.heading,
        "iress-u-text",
        {
          [e.divider]: a,
          [e[`menu--${s == null ? void 0 : s.layout}`]]: !!(s != null && s.layout)
        }
      ),
      role: d,
      children: [
        t && /* @__PURE__ */ o("div", { className: e.headingPrepend, children: t }),
        /* @__PURE__ */ o(l, { className: e.contents, children: i }),
        r && /* @__PURE__ */ o("div", { className: e.headingAppend, children: r })
      ]
    }
  );
};
g.Level = v;
export {
  g as IressMenuHeading
};
